module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-BoldItalic.8382e18.woff2";